import React, { Component } from "react";

export default class PledgeForm extends Component {
  render() {
    return (
      <div>

        Pledge Form
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PledgeForm.js